export const LOGO_BUILDER_COLOR = 'LOGO';
export const BUSINESS_CARDS_MAKER_COLOR = 'BCM';
export const BRAND_MAKER_COLOR = 'BM';
//# sourceMappingURL=LoginColors.js.map